// extracted by mini-css-extract-plugin
module.exports = {"shifts":"ShiftList_shifts__3O5DE"};